module.exports = __webpack_public_path__ + "img/Step2@3x.155a3973.jpg";